import { useEffect, useState } from "react"

interface TimeLeft {
  hours: string
  minutes: string
  seconds: string
}

const ZERO: TimeLeft = { hours: "00", minutes: "00", seconds: "00" }

function getTimeLeft(target: number): TimeLeft {
  const ms = Math.max(target - Date.now(), 0)
  const total = Math.floor(ms / 1000)
  const pad = (n: number) => n.toString().padStart(2, "0")
  return {
    hours: pad(Math.floor(total / 3600)),
    minutes: pad(Math.floor((total % 3600) / 60)),
    seconds: pad(total % 60),
  }
}

const UNITS: { key: keyof TimeLeft; label: string }[] = [
  { key: "hours", label: "hours" },
  { key: "minutes", label: "min" },
  { key: "seconds", label: "sec" },
]

interface TodayTimerProps {
  /** ISO timestamp to count down to (the daily `next_sync`). */
  target: string
}

/** Three-box hours/min/sec countdown to the next daily sync. Ported from the common Timer. */
export function TodayTimer({ target }: TodayTimerProps) {
  const targetMs = new Date(target).getTime()
  const [left, setLeft] = useState<TimeLeft>(() =>
    Number.isNaN(targetMs) ? ZERO : getTimeLeft(targetMs),
  )

  useEffect(() => {
    if (Number.isNaN(targetMs)) return
    const id = window.setInterval(() => setLeft(getTimeLeft(targetMs)), 1000)
    return () => window.clearInterval(id)
  }, [targetMs])

  return (
    <div className="flex items-center gap-1 text-center">
      {UNITS.map((unit) => (
        <div key={unit.key} className="w-11 rounded-lg bg-purple-light/10 py-2">
          <p className="font-display text-base font-medium text-purple-light">{left[unit.key]}</p>
          <p className="truncate font-body text-[10px] text-purple-light/40">{unit.label}</p>
        </div>
      ))}
    </div>
  )
}
